import { render, staticRenderFns } from "./CalendarItemComponent.vue?vue&type=template&id=ebfd4434&scoped=true"
import script from "./CalendarItemComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarItemComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfd4434",
  null
  
)

export default component.exports